<template>
  <div class="container">
    <h1>精臣打印SDK演示</h1>
    <div class="print_init">
      <h3>打印机初始化：</h3>
      <div class="content">
        <div class="service">
          <p class="service_status status">
            打印服务状态：{{ !printSocketOpen ? "未" : "已" }}连接
          </p>
        </div>
        <div class="select_usb">
          <div class="select_printer status">
            <label>选择USB打印机:</label>
            <select v-model="usbSelectPrinter" name="usbPrinters">
              <option value="" disabled v-if="!Object.keys(usbPrinters).length">
                请选择USB打印机
              </option>
              <option
                v-for="(value, name) in usbPrinters"
                :value="name"
                :key="name"
              >
                {{ name }}: {{ value }}
              </option>
            </select>
          </div>
          <button class="getPrinters" @click="getPrinters()" type="button">
            更新USB打印机列表
          </button>
        </div>

        <div class="connect_usb">
          <p class="usb_printer_connect_status status">
            打印机连接状态：USB打印机{{ !onlineUsbBool ? "未" : "已" }}连接
          </p>
          <button
            class="connect_printer"
            @click="selectOnLineUsbPrinter()"
            type="button"
          >
            连接USB打印机
          </button>
        </div>

        <div class="init">
          <div class="init_content">
            <p class="init_status status">
              SDK初始化状态：{{ !initBool ? "未" : "已" }}初始化
            </p>
            <button class="init_sdk status" @click="init()" type="button">
              初始化SDK
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="print_related">
      <h3>打印相关：</h3>
      <div class="content">
        <button
          class="print_label"
          @click="startPrintJobTest(textPrintData)"
          type="button"
        >
          文本打印(40-60)
        </button>
        <button
          class="print_label"
          @click="startPrintJobTest(barcodePrintData)"
          type="button"
        >
          一维码打印(40-20)
        </button>
        <button
          class="print_label"
          @click="startPrintJobTest(qrCodePrintData)"
          type="button"
        >
          二维码打印(30-30)
        </button>
        <button
          class="print_label"
          @click="startPrintJobTest(linePrintData)"
          type="button"
        >
          线条打印(40-20)
        </button>
        <button
          class="print_label"
          @click="startPrintJobTest(graphPrintData)"
          type="button"
        >
          图形打印（矩形、圆形）（40-20）
        </button>
        <button
          class="print_label"
          @click="startPrintJobTest(imgPrintData)"
          type="button"
        >
          图片打印（50-30）
        </button>
        <button
          class="print_label"
          @click="startPrintJobTest(combinationPrintData)"
          type="button"
        >
          多元素组合打印（50-30）
        </button>
        <button
          class="print_label"
          @click="startBatchPrintJobTest(batchPrintData)"
          type="button"
        >
          批量打印（50-30）
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { textPrintData } from "@/utils/printData/Text";
import { barcodePrintData } from "@/utils/printData/Barcode";
import { qrCodePrintData } from "@/utils/printData/QrCode";
import { linePrintData } from "@/utils/printData/Line";
import { graphPrintData } from "@/utils/printData/Graph";
import { imgPrintData } from "@/utils/printData/Img";
import { combinationPrintData } from "@/utils/printData/Combination";
import { batchPrintData } from "@/utils/printData/Batch";
export default {
  name: "HomeView",
  data() {
    const jsonObj = {
      printerImageProcessingInfo: {
        printQuantity: 1,
      },
    };
    return {
      textPrintData,
      barcodePrintData,
      qrCodePrintData,
      linePrintData,
      graphPrintData,
      imgPrintData,
      combinationPrintData,
      batchPrintData,
      jsonObj,
      // 打印服务是否连接成功
      printSocketOpen: false,
      nMPrintSocket: null,
      usbPrinters: {},
      wifiPrinters: {},
      onlineUsbBool: false,
      onlineWifiBool: false,
      usbSelectPrinter: "",
      wifiSelectPrinter: "",
      initBool: false,
      density: 3,
      label_type: 1,
      print_mode: 1,
      auto_shut_down: 1,
      wifiName: "",
      wifiPassword: "",
    };
  },
  mounted() {
    // 创建socket实例
    const socketData = new Socket("ws://127.0.0.1:37989");
    socketData.open(
      (openBool) => {
        console.log(openBool, "openBool");
        this.printSocketOpen = openBool;
      },
      (msg) => {
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info;
          if (callbackName == "onCoverStatusChange") {
            //盒盖状态：0-闭合、1-打开
            console.log("盒盖状态", msgInfo.capStatus);
          } else if (callbackName == "onElectricityChange") {
            //"power" : 0-4, // 电池电量等级（共5档）
            console.log("电池电量等级", msgInfo.power);
          }
        }
      }
    );
    // 创建打印实例
    this.nMPrintSocket = new NMPrintSocket(socketData);
  },
  methods: {
    //更新打印机列表
    async getPrinters() {
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }
      console.log("开始获取打印机");
      try {
        const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
        console.log(allPrintersRes, "allPrintersRes");
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          this.usbPrinters = { ...allPrinters };
          this.usbSelectPrinter = Object.keys(this.usbPrinters)[0];
          console.log("printers", this.usbPrinters);
        } else {
          alert("没有在线的打印机");
        }
      } catch (err) {
        console.error(err);
      }
    },
    async scanWifiPrinters() {
      const allPrintersRes = await this.nMPrintSocket.scanWifiPrinter();
      console.log("allPrintersRes", allPrintersRes);
      const errorCode = allPrintersRes.resultAck.errorCode;
      //处理搜索结果
      if (errorCode === 0) {
        const allPrinters = allPrintersRes.resultAck.info;
        this.wifiPrinters = {};
        allPrinters.forEach((item) => {
          this.wifiPrinters[item.deviceName] = item.tcpPort;
        });
        console.log("wifiPrinters", this.wifiPrinters);

        this.wifiSelectPrinter = Object.keys(this.wifiPrinters)[0];
        console.log("wifiSelectPrinter", this.wifiSelectPrinter);
      } else {
        alert("没有在线的打印机");
      }
    },
    //获取打印机Wifi配置信息
    async getWifiConfigurationInfo() {
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }
      try {
        const wifiInfo = await this.nMPrintSocket.getWifiConfiguration();
        const errorCode = JSON.parse(wifiInfo.resultAck.errorCode);

        if (errorCode === 0) {
          const info = JSON.parse(wifiInfo.resultAck.info);
          console.log("wifiInfo", info);
          alert("wifiInfo:" + info);
        } else {
          alert("wifiInfo:获取失败");
        }
      } catch (err) {
        console.error(err);
      }
    },

    async selectOnLineWifiPrinter() {
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }
      try {
        const wifiConnectRes = await this.nMPrintSocket.connectWifiPrinter(
          this.wifiSelectPrinter,
          parseInt(this.wifiPrinters[this.wifiSelectPrinter])
        );
        const result = JSON.parse(wifiConnectRes.resultAck.result);
        if (result) {
          console.log("连接成功");
          this.onlineWifiBool = true;
          this.onlineUsbBool = false;
        } else {
          console.log("连接失败");
          this.onlineWifiBool = false;
          alert("连接失败");
        }
        console.log("wifiConnectRes", wifiConnectRes);
      } catch (err) {
        console.error(err);
      }
    },

    async setWifiConfiguration() {
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }

      try {
        if (this.wifiName.trim() !== "") {
          const wifiConfigurationResult =
            await this.nMPrintSocket.configurationWifi(
              this.wifiName.trim(),
              this.wifiPassword.trim()
            );

          console.log("wifiConfigurationResult", wifiConfigurationResult);

          const errorCode = JSON.parse(
            wifiConfigurationResult.resultAck.errorCode
          );

          console.log("errorCode", errorCode);

          if (errorCode === 0) {
            return alert(
              "网络配置成功，请断开USB线缆后使用WIFI搜索连接打印机（PC需要和打印机在同一网络）"
            );
          } else {
            return alert("网络配置失败");
          }
        } else {
          return alert("wifi名称不得为空");
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 连接打印机
    async selectOnLineUsbPrinter() {
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }
      console.log("开始连接打印机");
      try {
        const res = await this.nMPrintSocket.selectPrinter(
          this.usbSelectPrinter,
          parseInt(this.usbPrinters[this.usbSelectPrinter])
        );
        console.log("选择打印机", res);

        if (res.resultAck.errorCode === 0) {
          console.log("连接成功");
          this.onlineUsbBool = true;
        } else {
          console.log("连接失败");
          this.onlineUsbBool = false;
          alert("连接失败");
        }
      } catch (err) {
        console.error(err);
      }
    },
    //初始化SDK
    async init() {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      //初始化数据
      try {
        const res = await this.nMPrintSocket.initSdk({ fontDir: "" });
        if (res.resultAck.errorCode == 0) {
          console.log("初始化成功");
          this.initBool = true;
        } else {
          console.log("初始化失败");
          this.initBool = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 打印机类型建议
    printerDetails(printModel) {
      switch (printModel) {
        case "B3S":
          alert(
            "B3S支持范围说明:\n打印模式支持：热敏\n打印浓度范围：1-5，建议值为3\n打印纸张类型支持：间隙纸、黑标纸、连续纸、透明纸"
          );
          break;
        case "B1":
          alert(
            "B1支持范围说明:\n打印模式支持：热敏\n打印浓度范围：1-5，建议值为3\n打印纸张类型支持：间隙纸、黑标纸、透明纸"
          );
          break;
        case "B203":
          alert(
            "B203支持范围说明:\n打印模式支持：热敏\n打印浓度范围：1-5，建议值为3\n打印纸张类型支持：间隙纸、黑标纸、透明纸"
          );
          break;
        case "B21":
          alert(
            "B21支持范围说明:\n打印模式支持：热敏\n打印浓度范围：1-5，建议值为3\n打印纸张类型支持：间隙纸、黑标纸、连续纸、透明纸"
          );
          break;
        case "D11/D101/D110/B16":
          alert(
            "D11/D101/D110/B16支持范围说明:\n打印模式支持：热敏\n打印浓度范围：1-3，建议值为2\n打印纸张类型支持：间隙纸、透明纸"
          );
          break;
        case "B32":
          alert(
            "B32支持范围说明:\n打印模式支持：热转印\n打印浓度范围：1-15，建议值为8\n打印纸张类型支持：间隙纸、透明纸"
          );
          break;
        case "Z401":
          alert(
            "Z401支持范围说明:\n打印模式支持：热转印\n打印浓度范围：1-15，建议值为8\n打印纸张类型支持：间隙纸、透明纸"
          );
          break;
        case "B50/B50W":
          alert(
            "B50/B50W支持范围说明:\n打印模式支持：热转印\n打印浓度范围：1-15，建议值为8\n打印纸张类型支持：间隙纸"
          );
          break;
        case "B18":
          alert(
            "B18支持范围说明:\n打印模式支持：热转印\n打印浓度范围：1-3，建议值为2\n打印纸张类型支持：间隙纸"
          );
          break;
        case "K3/K3W":
          alert(
            "K3/K3W支持范围说明:\n打印模式支持：热敏\n打印浓度范围：1-5，建议值为3\n打印纸张类型支持：间隙纸、黑标纸、透明纸"
          );
          break;
        case "M2":
          alert(
            "M2支持范围说明:\n打印模式支持：热转印\n打印浓度范围：1-5，建议值为3\n打印纸张类型支持：间隙纸、黑标纸、透明纸"
          );
          break;
        default:
          break;
      }
    },
    // 设置自动关机时间
    async setPrinterAutoShutDownTime(e) {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      console.log("setPrinterAutoShutDownTime", e.target.value);
      try {
        const res = await this.nMPrintSocket.setPrinterAutoShutDownTime(
          parseInt(e.target.value)
        );

        console.log("res", res);
        if (res.resultAck.errorCode === 0) {
          console.log("设置成功");
        } else if (res.resultAck.errorCode === -3) {
          console.log("不支持设置");
        } else {
          console.log("设置失败");
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 开始打印
    async startPrintJobTest(content) {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      let contentArr = [];
      contentArr.push(content);
      this.batchPrintJob(contentArr);
    },

    // 开始打印
    async startBatchPrintJobTest(content) {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      if (content == null || content.length == 0) {
        return;
      }
      this.batchPrintJob(content.data);
    },

    //批量打印列表数据
    async batchPrintJob(list) {
      const printQuantity =
        this.jsonObj.printerImageProcessingInfo.printQuantity;
      try {
        const startRes = await this.nMPrintSocket.startJob(
          this.density,
          this.label_type,
          this.print_mode,
          list.length * printQuantity
        );
        if (startRes.resultAck.errorCode == 0) {
          // 提交打印任务
          await this.printTag(list, 0);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 绘制打印标签
    async printTag(list, x) {
      console.log(list, x);
      //设置画布尺寸
      try {
        const res = await this.nMPrintSocket.InitDrawingBoard(
          list[x].InitDrawingBoardParam
        );
        if (res.resultAck.errorCode != 0) {
          return;
        }
        // 提交打印任务
        this.printItem(list, x, list[x].elements, 0);
      } catch (err) {
        console.error(err);
      }
    },
    async printItem(list, x, item, i) {
      try {
        if (i < item.length) {
          let arrParse;
          switch (item[i].type) {
            case "text":
              //绘制文本
              arrParse = await this.nMPrintSocket.DrawLableText(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "qrCode":
              arrParse = await this.nMPrintSocket.DrawLableQrCode(item[i].json);
              //绘制二维码
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "barCode":
              //绘制一维码
              arrParse = await this.nMPrintSocket.DrawLableBarCode(
                item[i].json
              );
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "line":
              //绘制线条
              arrParse = await this.nMPrintSocket.DrawLableLine(item[i].json);
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "graph":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableGraph(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }

              i++;
              await this.printItem(list, x, item, i);
              break;
            case "image":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableImage(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
          }
        } else {
          //遍历完成，开始打印
          const commitRes = await this.nMPrintSocket.commitJob(
            null,
            JSON.stringify(this.jsonObj)
          );
          //回调页码为数据总长度且回调打印份数数据等于当前页需要打印的份数数据时，结束打印任务
          if (
            commitRes.resultAck.printQuantity == list.length &&
            commitRes.resultAck.onPrintPageCompleted ==
              this.jsonObj.printerImageProcessingInfo.printQuantity
          ) {
            //结束打印任务
            const endRes = await this.nMPrintSocket.endJob();
            if (endRes.resultAck.errorCode === 0) {
              console.log("打印完成");
            }
            return;
          }
          //回调为提交成功，同时数据未发送完成时，可继续提交数据
          if (commitRes.resultAck.errorCode === 0 && x < list.length - 1) {
            //数据提交成功，数据下标+1
            console.log("发送下一页打印数据： ");
            x++;
            await this.printTag(list, x);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/HomeView.vue